import { notificationStore, NotificationType } from "../../store/notification";
import type { DiscoveryFilter } from "../../types/filters/common";
import { InsightFamiliesFilterField } from "../../types/filters/insightFamilies";
import {
    getAdvertiserId,
    getMarketplaceId,
} from "../../utils/permission.utils";

export const insightFamiliesFilters: DiscoveryFilter[] = [
    {
        label: "Brand",
        field: InsightFamiliesFilterField.BRAND,
        isAdditional: true,
        additionalActionButtons: [
            {
                label: "Manage Brand/Businessline Preferences",
                external: true,
                onClick: (): void => {
                    const marketplaceId = getMarketplaceId();
                    const sfId = getAdvertiserId();
                    if (!marketplaceId || !sfId) {
                        notificationStore
                            .getState()
                            .upsertNotification(
                                "Missing either marketplace id or advertiser id",
                                NotificationType.ERROR,
                            );
                        return;
                    }
                    const searchParams = new URLSearchParams();
                    searchParams.set("marketplaceId", marketplaceId);
                    searchParams.set("sfId", sfId);
                    window.open(`/icm?${searchParams.toString()}`, "_blank");
                },
            },
        ],
        groupConfiguration: {
            Businessline: {
                priority: 10,
            },
            Brand: {},
        },
    },
    {
        label: "Browse node",
        field: InsightFamiliesFilterField.BROWSE_NODE,
        isAdditional: true,
    },
    {
        label: "Objective",
        field: InsightFamiliesFilterField.OBJECTIVE,
        isAdditional: true,
    },
];

export const defaultInsightFamiliesFilters = insightFamiliesFilters.filter(
    (filter) =>
        [
            InsightFamiliesFilterField.BRAND,
            InsightFamiliesFilterField.BROWSE_NODE,
        ].includes(filter.field as InsightFamiliesFilterField),
);
